<style>
        /* Ejemplo de clases CSS en tu archivo de estilos */

    .notification-icon-orange {
        color: #ff9800; /* Naranja de Material */
    }

    .notification-icon-green {
        color: #4caf50; /* Verde de Material */
    }

    .notification-icon-blue {
        color: #2196f3; /* Azul de Material */
    }

    .notification-icon-red {
        color: #f44336; /* Rojo de Material */
    }

    .notification-icon-light-blue {
        color: #03a9f4; /* Azul claro de Material */
    }

    .notification-icon-deep-purple {
        color: #673ab7; /* Morado Oscuro de Material */
    }

    .notification-icon-default {
        color: #9e9e9e; /* Gris de Material */
    }


    /*.notification-icon-red {
        color: red !important;
    }

    .notification-icon-blue {
        color: blue !important;
    }

    .notification-icon-green {
        color: green !important;
    }

    .notification-icon-default {
        color: gray !important;
    }*/
</style>
<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<ng-template #notificationsPanel>
    <div
        class="fixed inset-0 sm:static sm:inset-auto flex flex-col w-[20rem] sm:w-[40rem] sm:rounded-2xl overflow-hidden shadow-lg"
    >
        <div
            class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary"
        >
            <div class="text-lg font-medium w-[90%]">
                {{ "NOTIFICACIONES_DE_VIAJE" | translate }}
            </div>
            <div class="w-[10%]">
                <button
                    mat-icon-button
                    [matTooltip]="'Cerrar'"
                    (click)="closePanel()"
                >
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_solid:x'"
                    ></mat-icon>
                </button>
            </div>
        </div>

        <div
            class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card"
        >
            <ng-container
                *ngFor="let notification of notifications; trackBy: trackByFn"
            >
                <div
                    class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5 cursor-pointer"
                >
                    <div class="flex flex-auto py-5 pl-6">
                        <ng-container
                            *ngTemplateOutlet="
                                notificationContent;
                                context: { $implicit: notification }
                            "
                        ></ng-container>
                    </div>
                </div>
            </ng-container>

            <ng-template #notificationContent let-notification>
                <div
                    class="flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full bg-white shadow-md dark:bg-gray-800"
                >
                    <mat-icon
                        class="icon-size-7"
                        [svgIcon]="getNotificationSvgIcon(notification.proceso)"
                        [class]="
                            getNotificationIconColorClass(notification.proceso)
                        "
                    >
                    </mat-icon>
                </div>

                <div class="flex flex-col flex-auto">
                    <ng-container *ngIf="notification.proceso">
                        <div class="flex justify-between items-start w-full">
                            <div
                                class="font-medium text-gray-900 dark:text-white"
                            >
                                {{ notification.proceso }} - Viaje #{{
                                    notification.viajeId
                                }}
                            </div>

                            <div
                                class="**shrink-0** **text-sm** text-secondary dark:text-gray-500 **ml-4**"
                            >
                                {{
                                    notification.fecha | date : "MMM dd, h:mm a"
                                }}
                            </div>
                        </div>
                    </ng-container>

                    <div class="text-base text-gray-600 dark:text-gray-400">
                        {{ notification.mensaje }}
                    </div>
                </div>

            </ng-template>

            <ng-container *ngIf="!notifications || !notifications.length">
                <div
                    class="flex flex-col flex-auto items-center justify-center py-8 px-4 text-secondary"
                >
                    <mat-icon
                        [svgIcon]="'heroicons_outline:bell-slash'"
                        class="w-12 h-12 mb-4"
                    ></mat-icon>
                    <div class="text-lg font-medium">
                          {{ "NO_TIENES_NOTIFICACIONES" | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
